<!--/**-->
<!--* 自动生成 vue列表代码【模块名：分成锁定记录】-->
<!--* 生成日期：2025/12/15 16:16:16-->
<!--* 生成路径: src/pages/artist_divide_lock/ArtistDivideLockList.vue-->
<!--* 生成人：管理员-->
<!--*/-->
<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <div class='table-search'>
          <el-form :model='searchCondition' inline size='mini'>
            <el-form-item label='锁定的月份'>
              <el-input v-model='searchCondition.date_time' placeholder='锁定的月份' clearable></el-input>
            </el-form-item>
            <el-form-item label='创建人'>
              <el-input v-model='searchCondition.created_by' placeholder='创建人' clearable></el-input>
            </el-form-item>
            <el-form-item label='修改人'>
              <el-input v-model='searchCondition.updated_by' placeholder='修改人' clearable></el-input>
            </el-form-item>

            <el-form-item label='创建时间'>
              <el-date-picker
                v-model='searchCondition.date_range'
                type='daterange'
                align='right'
                unlink-panels
                range-separator='至'
                start-placeholder='开始日期'
                end-placeholder='结束日期'
                value-format='yyyy-MM-dd'
                :picker-options='pickerOptions'>
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' icon='el-icon-search' :disabled='loading' :loading='loading' @click='handleQuery'>搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--        操作栏-->
        <div class='mb8 default-panel flex-left theme-border'>
          <div>
            <el-button type='primary' icon='el-icon-plus' v-if='hasAuthority("artist_divide_lock_create")' @click='handleAdd'>新增</el-button>
          </div>
          <div>
            <el-button icon='el-icon-upload' v-if='hasAuthority("artist_divide_lock_import")' @click='openImport=true'>导入</el-button>
          </div>
          <div>
            <export-btn ref='refLogisticSubscribeExport' :can-export='hasAuthority("artist_divide_lock_export")' @export='handleExport'></export-btn>
          </div>
        </div>
        <!-- 列表页签 -->
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
          <el-tab-pane label="列表" name="list">
            <!--    渲染表格-->
            <div class='default-table'>
              <MlPageTable :all-columns='defaultColumns'
                           :table-name='tableName'
                           :data-list='dataList'
                           :limit.sync='pageData.page_size'
                           :page.sync='pageData.current_page'
                           :total.sync='total'
                           highlight-current-row
                           :row-class-name='tableRowClassName'
                           @row-click='rowClickEvent'
                           @getList='getList' border>
                <el-table-column align='center' width='120' label='操作' fixed='right'>
                  <template slot-scope='{row,$index}'>
                    <el-button type='text' icon='el-icon-edit' v-if='hasAuthority("artist_divide_lock_edit")' @click='handleEdit(row)'>修改</el-button>
                    <el-button type='text' icon='el-icon-delete' v-if='hasAuthority("artist_divide_lock_delete")' @click='handleDelete(row,$index)'>删除</el-button>
                  </template>
                </el-table-column>
              </MlPageTable>
            </div>
          </el-tab-pane>
          <el-tab-pane label="使用说明" name="use_note">
            <div class='theme-border default-padding mb8' style='min-height: 400px'>
              <ul>
                <li>使用流程：</li>
                <li>数据来源：</li>
                <li>权限说明：</li>
              </ul>
            </div>
          </el-tab-pane>

        </el-tabs>


      </div>

      <!-- 添加或修改对话框 -->
      <el-dialog :title='title' :visible.sync='open' width='800px' append-to-body :close-on-click-modal='false'>
        <el-form ref='form' :model='form' :rules='rules' label-width='100px'>
          <el-form-item label='锁定的月份' prop='date_time'>
            <el-input v-model='form.date_time' placeholder='请输入锁定的月份' clearable/>
          </el-form-item>
          <el-form-item label='创建人' prop='created_by'>
            <el-input v-model='form.created_by' placeholder='请输入创建人' clearable/>
          </el-form-item>
          <el-form-item label='修改人' prop='updated_by'>
            <el-input v-model='form.updated_by' placeholder='请输入修改人' clearable/>
          </el-form-item>

        </el-form>
        <div slot='footer' class='dialog-footer'>
          <el-button type='primary' @click='submitForm' :disabled='loadingCommit' :loading='loadingCommit'>确 定
          </el-button>
          <el-button @click='cancel'>取 消</el-button>
        </div>
      </el-dialog>
      <!--      导入-->
      <ImportArtistDivideLock :visible.sync='openImport' v-if='hasAuthority("artist_divide_lock_import")' @imported='handleQuery' />
    </PageHeaderLayout>
  </div>
</template>

<script>
import MlPageTable from '@/components/common/MlPageTable'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ExportBtn from '@/components/export/ExportBtn'
import ImportArtistDivideLock from './ImportArtistDivideLock'
import { deleteArtistDivideLock, exportArtistDivideLocks, getArtistDivideLockInfo, getArtistDivideLockList, saveArtistDivideLock } from '@/api/artist_divide_lock'

export default {
  name: 'ArtistDivideLockList',
  components: { ImportArtistDivideLock, ExportBtn, PageHeaderLayout, MlPageTable },
  data() {
    return {
      tableName: 'artist_divide_lock',
      activeName: 'list',
      loading: false,
      loadingCommit: false,
      dataList: [],
      total: 0,
      height: 800,
      searchCondition: { date_range: [],date_time: null, created_by: null, updated_by: null},
      pageData: { current_page: 1, page_size: 100 },
      orderBy: { id: 'asc' },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      defaultColumns:  [{ hide: false, prop: 'id', label: '序号', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'date_time', label: '锁定的月份', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'created_by', label: '创建人', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'updated_by', label: '修改人', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'created_at', label: '创建时间', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'updated_at', label: '修改时间', width: 120, sortable: true, fixed: false },
        // { hide: false, prop: 'deleted_at', label: '删除时间', width: 120, sortable: true, fixed: false }
        ],
      // 弹出层标题
      title: '添加/修改-分成锁定记录',
      // 是否显示弹出层
      open: false,
      // 表单校验
      rules:{date_time: [{ required: true, message: '锁定的月份不能为空', trigger: 'blur' }],
        created_by: [{ required: true, message: '创建人不能为空', trigger: 'blur' }],
        updated_by: [{ required: true, message: '修改人不能为空', trigger: 'blur' }]},
      // 表单参数
      form: {},
      //是否显示弹出层:导入框
      openImport: false,
      //筛选条件缓存key
      pageSearchKey:'page_search_key:artist_divide_lock'
    }
  },
  methods: {
    handleTabClick(){
      // console.log(this.activeName)
    },
    // eslint-disable-next-line no-unused-vars
    rowClickEvent(row, column, event) {
      // this.$notify.info(`数据ID：${row.id}`)
    },
    // eslint-disable-next-line no-unused-vars
    tableRowClassName({ row, rowIndex }) {
      return 'default-table-row'
    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field] != null) {
          condition[field] = this.searchCondition[field]
        }
      })

      // 分页 +排序
      Object.assign(condition, this.pageData, { orderBy: this.orderBy })

      return condition
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
      //缓存筛选条件，刷新后可以继续使用
      sessionStorage.setItem(this.pageSearchKey, JSON.stringify(this.searchCondition))
    },
    async getList() {
      this.dataList = []
      this.loading = true
      const params = this.handleSearchCondition()
      const { list, pages } = await getArtistDivideLockList(params)
      // this.dataList = [...this.dataList, ...list]
      this.dataList = list
      this.pageData.current_page = pages.current_page || 1
      this.pageData.page_size = pages.page_size || 100
      this.total = pages.total
      this.loading = false
    },
    /** 删除按钮 */
    handleDelete(row, index) {
      if (row.id) {
        //真实删除
        this.$confirm('此操作将删除该行数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delRow(row.id)
          this.dataList.splice(index, 1)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        this.tableData.splice(index, 1)
      }
    },
    async delRow(id) {
      await deleteArtistDivideLock(id)
    },
    /** 修改按钮 */
    handleAdd() {
      this.open = true
      this.title = '添加-分成锁定记录'
      this.form = {}
    },
    /** 修改按钮 */
    async handleEdit(row) {
      this.open = true
      this.title = '修改-分成锁定记录'
      const { info } = await getArtistDivideLockInfo(row.id)
      this.form = { ...info }
    },

    /** 提交按钮 */
    async submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loadingCommit = true
          saveArtistDivideLock(this.form).then(id => {
            if (id) {
              if (!this.form.id)
                this.msgSuccess('新增成功')
              else
                this.msgSuccess('修改成功')

              this.form.id = id
              this.open = false
              this.getList()
            } else {
              this.msgError('操作失败')
            }
            setTimeout(() => {
              this.loadingCommit = false
            }, 500)
          })

        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.form = {}
    },
    //导出表格
    async handleExport() {
      try {
        const searchCondition = this.handleSearchCondition()
        const response = await exportArtistDivideLocks(searchCondition)
        const name = `分成锁定记录`

        this.$refs.refLogisticSubscribeExport.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
        this.$refs.refLogisticSubscribeExport.hideLoading()
      }
    },
  },
  created() {
    if (sessionStorage.getItem(this.pageSearchKey)) {
      this.searchCondition = JSON.parse(sessionStorage.getItem(this.pageSearchKey))
    }
    this.handleQuery()
  }
}
</script>

<style scoped>

</style>
